<template>
  <!-- 休日出勤報告修正 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>休日出勤報告修正</h2>
      </CCardHeader>
      <CCardBody>
        <span class="preika-required-note"><span class="preika-required-note__mark" aria-hidden="true">*</span><span>が付いている項目は必須入力項目です</span></span>

        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table table-borderless preika-report-form">

                <!-- 日付 -->
                <tr>
                  <th scope="row">日付<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" class="preika-report-field preika-report-field--date">
                        <ValidationProvider name="日付" rules="required" v-slot="ProviderProps">
                          <CInput
                            class="preika-form-control preika-form-control--native-icon"
                            type="date"
                            :min="date_min()"
                            :max="date_max()"
                            v-model="holiday_work_date"
                          />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 予定時間 -->
                <tr>
                  <th scope="row">予定時間<span class="asterisk">*</span></th>
                  <td>
                    <CRow class="preika-report-time-row">
                      <CCol sm="12" md="6" class="preika-report-field preika-report-field--time">
                        <ValidationProvider name="開始予定時間" rules="required" v-slot="ProviderProps">
                          <label>開始予定時間<span class="asterisk">*</span></label>
                          <CInput class="preika-form-control preika-form-control--native-icon" type="time" v-model="start_time" />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>

                      <CCol sm="12" md="6" class="preika-report-field preika-report-field--time">
                        <ValidationProvider name="終了予定時間" rules="required" v-slot="ProviderProps">
                          <label>終了予定時間<span class="asterisk">*</span></label>
                          <CInput class="preika-form-control preika-form-control--native-icon" type="time" v-model="end_time" />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 発生理由 -->
                <tr>
                  <th scope="row">発生理由<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" class="preika-report-field preika-report-field--wide">
                        <ValidationProvider name="発生理由" rules="required|max:100" v-slot="ProviderProps">
                          <CTextarea
                            class="preika-report-reason-input"
                            v-model="reason"
                            rows="4"
                          />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <save-button
                    :label="'報告'"
                    :loading="loading"
                    @click="whenValid('obs', update)"
                    class="btn btn-primary"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 保存すると上長向けの報告一覧へ反映されます。自分の申請一覧での申請操作はありません。</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import submitWhenValidMixin from '@/mixins/submitWhenValidMixin'
import ConstList from "./../../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import axios from "axios";
import SaveButton from '../../common/SaveButton';
import {
  buildSaveParams,
  isReportableFailure,
  saveErrorMessage,
  toTimeInputValue,
} from "./holidayWorkSave";
export default {
  mixins: [submitWhenValidMixin],
  components: { SaveButton },
  name: "UpdateInput",
  data() {
    return {
      holiday_work_date: "",
      start_time: "",
      end_time: "",
      reason: "",
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },
  // DBから各種情報を取得
  mounted: function () {
    this.id = this.$route.params.id;
    const id = parseInt(this.id);
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/holidayWork/" + id)
      .then((response) => {
        if (response.data.length === 0) {
          this.errors.push(ConstList.RECORD_NOT_FOUND);
        }
        const holidayWorkData = response.data;
        this.holiday_work_date = holidayWorkData.date;
        // APIは HH:mm:ss を返すが <input type="time"> が返すのは HH:mm。
        // 画面が持つ形を先に揃えておかないと、時刻を触ったかどうかで
        // 保存時に送る形が変わってしまう。
        this.start_time = toTimeInputValue(holidayWorkData.start_time);
        this.end_time = toTimeInputValue(holidayWorkData.end_time);
        this.reason = holidayWorkData.reason;
      })
      .catch((error) => {
        axios
        .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
        .then(() => {
          alert(requestFailureMessage(error));
        })
        .catch(() => {
          alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
      });
  },
  methods: {
    // 受け付ける日付の範囲は新規画面と同じにする。
    // 修正だけ上下限が無いと、新規が拒む日付へ後から動かせてしまう。
    date_min() {
      return ConstList.DATE_MIN;
    },
    date_max() {
      return ConstList.DATE_MAX;
    },
    // 修正情報を送信
    update: function () {
      // 二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;
      if (confirm) {
        this.loading = true;
        // 送る形は新規画面と同じ組み立てを使う。
        const params = buildSaveParams({
          date: this.holiday_work_date,
          startTime: this.start_time,
          endTime: this.end_time,
          reason: this.reason,
        });
        this.id = this.$route.params.id;
        const id = parseInt(this.id);
        return axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/holidayWorkUpdate/" + id,
            params
          )
          .then((response) => {
            this.submit_flg = false;
            if (response.data === ConstList.SUCCESS) {
              alert(ConstList.REGISTER_MESSAGE);
              this.$router.push({ name: "休日出勤報告" });
            } else {
              alert(ConstList.APPLY_ERROR);
            }
          })
          .catch((error) => {
            this.submit_flg = false;
            // 入力の不備や他人の報告への操作はBackendが文言つきで断る。
            // 障害ではないのでfrontErrorへは積まず、その文言を出す。
            if (!isReportableFailure(error)) {
              alert(saveErrorMessage(error, ConstList.APPLY_ERROR));
              return;
            }
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(requestFailureMessage(error));
            })
            .catch(() => {
              alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    valueCheck: function () {
      if ((this.holiday_work_date != 0) || 
        (this.start_time != '') ||
        (this.end_time != '') || 
        (this.reason != '')) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_HOLIDAYWORKS_INFO,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_HOLIDAYWORKS_INFO,
        })
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
